/* SILA header, announcement and drawer behavior. */

(() => {
  const body = document.body;
  const isHome = body.classList.contains('template-index');
  let announcementElement = null;
  let resizeFrame = 0;
  let announcementResizeObserver = null;

  const updateHeaderState = () => {
    if (!isHome) return;
    body.classList.toggle('sila-header-scrolled', window.scrollY > 32);
  };

  const measureAnnouncement = () => {
    let offset = 0;
    let matchedElement = null;
    const candidates = document.querySelectorAll(
      '[class*="announcement" i], [id*="announcement" i], [class*="oxify" i], [id*="oxify" i]'
    );

    candidates.forEach((element) => {
      if (element.closest('.section-header')) return;
      const style = window.getComputedStyle(element);
      const rect = element.getBoundingClientRect();
      if (
        style.display !== 'none' &&
        style.visibility !== 'hidden' &&
        rect.width > window.innerWidth * 0.6 &&
        rect.height >= 20 &&
        rect.height <= 120 &&
        rect.top >= -10 &&
        rect.top <= 20 &&
        rect.bottom > offset
      ) {
        offset = Math.round(rect.bottom);
        matchedElement = element;
      }
    });

    document.documentElement.style.setProperty('--sila-announcement-offset', `${offset}px`);

    if (matchedElement && matchedElement !== announcementElement) {
      announcementElement = matchedElement;
      announcementResizeObserver?.disconnect();
      if ('ResizeObserver' in window) {
        announcementResizeObserver = new ResizeObserver(scheduleAnnouncementMeasure);
        announcementResizeObserver.observe(announcementElement);
      }
    }

    return Boolean(matchedElement);
  };

  const scheduleAnnouncementMeasure = () => {
    window.cancelAnimationFrame(resizeFrame);
    resizeFrame = window.requestAnimationFrame(measureAnnouncement);
  };

  updateHeaderState();
  measureAnnouncement();

  if (isHome) window.addEventListener('scroll', updateHeaderState, { passive: true });
  window.addEventListener('resize', scheduleAnnouncementMeasure, { passive: true });

  [250, 900, 1800, 3000].forEach((delay) => window.setTimeout(scheduleAnnouncementMeasure, delay));

  const mutationObserver = new MutationObserver(scheduleAnnouncementMeasure);
  mutationObserver.observe(document.body, { childList: true, subtree: true });
  window.setTimeout(() => mutationObserver.disconnect(), 4000);
})();

/* SILA v1.3.2: close the full-page drawer when its real backdrop is clicked. */
(() => {
  const bindSidebarBackdrops = (root = document) => {
    root.querySelectorAll('[data-sila-sidebar-backdrop]').forEach((backdrop) => {
      if (backdrop.dataset.silaBound === 'true') return;
      backdrop.dataset.silaBound = 'true';
      backdrop.addEventListener('click', () => {
        const details = backdrop.closest('details[open]');
        const summary = details?.querySelector(':scope > summary');
        summary?.click();
      });
    });
  };

  bindSidebarBackdrops();
  document.addEventListener('shopify:section:load', (event) => bindSidebarBackdrops(event.target));
})();
